import { render, staticRenderFns } from "./SingleItemConstructor.vue?vue&type=template&id=d0a8c8d6"
import script from "./SingleItemConstructor.vue?vue&type=script&lang=js"
export * from "./SingleItemConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0a8c8d6')) {
      api.createRecord('d0a8c8d6', component.options)
    } else {
      api.reload('d0a8c8d6', component.options)
    }
    module.hot.accept("./SingleItemConstructor.vue?vue&type=template&id=d0a8c8d6", function () {
      api.rerender('d0a8c8d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/single-item-constructor/SingleItemConstructor.vue"
export default component.exports